(async function () {
  if (window.location.href.indexOf('localhost') !== -1) {
    return;
  }

  let searchParams = new URLSearchParams(window.location.search);
  let url_top = 'https://' + window.location.host
  
  if(searchParams.has('checkout_url')){
    let searchParamStr = searchParams.get('checkout_url');
    if( searchParamStr.indexOf('checkouts') !== -1 && searchParamStr.indexOf('step') !== -1 && searchParamStr.indexOf('contact_information') !== -1 ){
      window.location.href = url_top;
      return;
    }
  }

  // multipass redirect
  let url;
  switch (window.location.host) {
    case 'chocozap.myshopify.com':
    case 'chocozap.shop':
      // production
      url = 'https://login.chocozap.shop/multipass/auth';
      break;
    case 'chocozap-dev.myshopify.com':
    case 'dev.chocozap.shop':
      // staging
      url = 'https://login.dev.chocozap.shop/multipass/auth';
      break;
  }

  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}

  const GA_TAG_ID = 'G-FGC5TSTK9F';
  const clientIdPromise = new Promise(resolve => {
    gtag('get', GA_TAG_ID, 'client_id', resolve);
  });
  const sessionIdPromise = new Promise(resolve => {
    gtag('get', GA_TAG_ID, 'session_id', resolve);
  });

  const [ga_client_id, ga_session_id] = await Promise.all([clientIdPromise, sessionIdPromise]);

  if (url) {
    const params = new URLSearchParams(location.search);
    const return_url = params.get('return_url') || params.get('checkout_url') || encodeURIComponent(document.referrer);

    let redirectUrl = url + '/?return_to=' + return_url;

    if(ga_client_id && ga_session_id) {
      const redirectParams = new URLSearchParams();
      redirectParams.set('ga_client_id', ga_client_id);
      redirectParams.set('ga_session_id', ga_session_id);
      redirectUrl = redirectUrl + '&' + redirectParams.toString();
    }

    window.location.href = redirectUrl;
  }
})();
